// extracted by mini-css-extract-plugin
export default {"container":"PageSkeleton_container__1d5of","table":"PageSkeleton_table__Qcun2","delete":"PageSkeleton_delete__UeDxF","action":"PageSkeleton_action__w6ml8"};